import { BaseEntityWithChildIdsInterface } from '../schemas/base-entity.schema'
import { PageEntityInterface } from '../types/base-entity-interface'

export function isEntityWithChildIds(
  entity: PageEntityInterface,
): entity is BaseEntityWithChildIdsInterface {
  return 'childIds' in entity
}
